import { FC } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  border-top: 1px solid var(--gray-200);
  display: grid;
  grid-template-columns: 20rem 1fr;
  > * {
    padding: 1.25rem 0;
  }
  overflow-x: auto;
  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
    padding: 1rem 0;
    & > * {
      padding: 0.25rem 0;
    }
  }
`;

const Label = styled.div`
  font-size: 0.9rem;
  color: var(--gray-700);
  min-width: 5rem;
  padding-right: 2rem;
  div {
    height: 100%;
    display: flex;
  }
`;

const LabelContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 0.5rem;
  width: fit-content;

  @media (max-width: 1200px) {
    color: var(--gray-400);
  }
`;

const Content = styled.div`
  display: flex;
  max-width: 40rem;
  column-gap: 1.5rem;
  & > * {
    /* margin-right: 1.5rem; */
    width: 100%;
  }
`;

type Props = {
  label: string | React.ReactElement;
};
const Field: FC<Props> = ({ children, label }) => {
  return (
    <Container>
      <Label>
        <LabelContainer>{label}</LabelContainer>
      </Label>
      <Content>{children}</Content>
    </Container>
  );
};

export default Field;
